import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';

import { QUERY_KEYS } from '@/utils/query-keys';
import { ErgonomicWorkAnalysisActionPlanService } from '@/infra/services/ergonomic-work-analysis-action-plan';
import type { UpdateErgonomicWorkAnalysisActionPlanRequestDTO } from '@/core/dto/ergonomic-work-analisys';

const Service = ErgonomicWorkAnalysisActionPlanService.getInstance();

export const useUpdateEWAActionPlan = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params: UpdateErgonomicWorkAnalysisActionPlanRequestDTO) => Service.update(params),
		onSuccess: () => {
			message.success(I18n.get('Action plan updated successfully'));
			queryClient.invalidateQueries([QUERY_KEYS.GET_ACTION_PLANS_EWA]);
		},
		onError: () => {
			message.error(I18n.get('Error updating action plan'));
		}
	});
};
